import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import {
  HRService,
  setupManagementUrl,
  userManagementUrl,
} from "../../../../config";
import {
  allLeaveTypes,
  allUsers,
} from "../../../../data/Queries/HRmanagement/leavemanagement";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { leavePolicyFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";

const base_url = HRService.uri;

const ImprestApproversForm = (props) => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    leaveTypeId: props.data ? props.data.leaveTypeId : "",
    gender: props.data ? props.data.gender : "",
    acrues: props.data ? props.data.acrues : false,
    accrualRate: props.data ? props.data.accrualRate : "",
    accrualDate: props.data ? props.data.accrualDate : "",
    canCarryForward: props.data ? props.data.canCarryForward : false,
    maxDaysCarryForward: props.data ? props.data.maxDaysCarryForward : "",
    maxOpenApplications: props.data ? props.data.maxOpenApplications : "",
    maxDays: props.data ? props.data.maxDays : "",
  };

  useEffect(() => {
    async function fetchLeaveTypes() {
      try {
        const data = await graphqlQuery(allUsers, userManagementUrl.uri);
        if (data) {
          setLeaveTypes(data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchLeaveTypes();
  }, []);

  const LeaveTypeOptions = leaveTypes
    ? leaveTypes.map((type) => ({
        value: type.id,
        label: type.username,
      }))
    : [];

  const fields = [
    {
      name: "userId",
      label: "Approvers",
      type: "select",
      options: LeaveTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: true,
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        userId: values.userId,
        isActive: 1,
      };
      const response = await generateAndExecuteMutation(
        "addRemoveRequisitionApprover",
        mutationData,
        "approvers",
        base_url
      );
      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Approver(s) added successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={[{
        stepNumber: 1,
        stepLabel: "Imprest Approvers",
        stepDescription: "Enter approvers information",
        fields: fields.map(f => f.name),
      }]}
      onSubmit={handleSubmit}
      title="Approvers management"
      subtitle="Select Approvers."
    />
  );
};

export default ImprestApproversForm;
